<template>
    <section v-show="item.selected">
        <a
                class="item-image-counter"
                v-if="photos.length > 3"
                :href="link(template.photos)" target="_blank">
            +{{photos.length - 3}}
        </a>

        <a
                class="item-image-container"
                v-for="(photo, idx) in photos"
                v-show="idx < 3"
                :key="'photo-' + idx"
                :data-lightbox="item.id"
                :data-title="photo.description"
                :href="photo.uri">
            <img :alt="photo.description" v-lazy="photo.uri">
        </a>

        <p v-for="(value, key) in template.fields" :key="'field-' + key">
            <b>{{value.label}}</b>
            <a v-if="value.type == 'link'" :href="link(value)" target="_blank">
                <!--'&type=borders'-->
                {{_.get(item.object, [value.attribute]) | fallback}}
            </a>
            <span v-else-if="value.type == 'text'">{{_.get(item.object, [value.attribute]) | fallback}}</span>
            <span v-else-if="value.type == 'date'">{{_.get(item.object, [value.attribute]) | date | fallback}}</span>
        </p>
        <div class="map-result-hint" v-if="!item.layer">Объекта нет на карте</div>
    </section>
</template>

<script>
    import 'lightbox2/dist/images/close.png'
    import 'lightbox2/dist/images/next.png'
    import 'lightbox2/dist/images/prev.png'
    import 'lightbox2/dist/images/loading.gif'

    import lightbox from 'lightbox2/dist/js/lightbox-plus-jquery.js'
    import '!file?name=lightbox/[name].[ext]!lightbox2/dist/css/lightbox.min.css'

    lightbox.option({
        'albumLabel': 'Изображение %1 из %2',
        'resizeDuration': 400,
        'fadeDuration': 400,
        'imageFadeDuration': 400,
        'wrapAround': true
    });

    export default {
        props: ['item', 'template'],
        methods: {
            link(field) {
                let idParam = _.get(field, ['link', 'id']);
                return _.get(field, ['link', 'base'])
                    + '?id=' + _.get(this.item, ['object', idParam])
                    + '&type=' + _.get(field, ['link', 'type']);
            },
        },
        computed: {
            photos() {
                let photos = (this.template.photos && this.item.object.Photos) ? JSON.parse(this.item.object.Photos) : [];
                return _(photos).filter('uri').sortBy('description').value();
            }
        }
    }
</script>

<style scoped>
    .item-image-container {
        width: 100px;
        height: 76px;
        display: inline-block;
        border: 1px solid #bdbdbd;
        margin: -8px 9px 10px 0;
        padding: 1px;
        box-shadow: 0px 0px 3px rgba(0,0,0,0.2);
    }

    .item-image-container img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .item-image-counter {
        display: block;
        position: absolute;
        background: rgba(255,255,255,0.95);
        top: 24px;
        right: 12px;
        height: 22px;
        padding: 3px 5px 0 5px;
        border-radius: 11px;
        border: 1px solid rgba(191, 191, 191, 0.95);
        box-shadow: 0 0 1px rgba(0,0,0,0.3);
        font-size: 11px;
        color: #272727;
    }

    .item-image-counter:hover {
        color: #000;
        background-color: white;
    }

    .item-image-container:hover,
    .item-image-counter:hover {
        border-color: #72afd2;
        box-shadow: 0px 0px 3px rgba(0,0,0,0.4);
    }
</style>


// WEBPACK FOOTER //
// TemplateShapeView.vue?553812ff